export const IMAGE_TOOLS_TOKENS = {
  // Workspace dimensions keep the review layout consistent across the desktop,
  // tablet, and mobile compositions described by the unified-editor spec.
  motion: {
    pressScale: 0.98,
  },
  opacity: {
    regionOverlay: 0.28,
  },
  size: {
    contentMaxWidth: 1120,
    uploadMinHeight: 176,
    previewHeight: 190,
    coverPreview: 72,
    iconButton: 44,
    progressHeight: 8,
    progressComplete: "100%",
    mobileBreakpoint: 768,
    tabletBreakpoint: 1024,
    gridMinWidth: 240,
    actionMinWidth: 180,
    dialogMaxWidth: 480,
    editorMaxHeight: 560,
    workspaceCanvasMinHeight: 320,
    workspaceInspectorWidth: 288,
    workspaceNavigatorWidth: 88,
    workspaceRailWidth: 72,
    workspaceThumbnail: 64,
    stickerMinSide: 16,
    regionMinSide: 44,
    filterOptionDesktop: 100,
    filterOptionMobile: 72,
    filterIconDesktop: 48,
    filterIconMobile: 32,
    comingSoonOffset: -8,
    exportHistoryAspectRatio: 1,
    exportHistoryCardMobile: "47%",
    exportHistoryCardTablet: "31%",
    exportHistoryCardDesktop: "23%",
  },
} as const;
